module.exports = __webpack_public_path__ + "img/hm.37b30fb7.svg";